<template>
  <div class="show_all_content_wrapper">
    <!-- Start:: Main Section -->
    <main>
      <!--  =========== Start:: Filter Form =========== -->
      <div class="filter_content_wrapper" :class="{ active: filterFormIsActive }">
        <button class="filter_toggler" @click="filterFormIsActive = !filterFormIsActive">
          <i class="fal fa-times"></i>
        </button>
        <div class="filter_title_wrapper">
          <h5>{{ $t("TITLES.searchBy") }}</h5>
        </div>

        <div class="filter_form_wrapper">
          <form @submit.prevent="submitFilterForm">
            <div class="row justify-content-center align-items-center w-100">
              <!-- Start::company name Input -->
              <base-input col="4" type="text" :placeholder="$t('PLACEHOLDERS.driver_name')"
                v-model.trim="filterOptions.provider_name" />
              <base-input col="4" type="text" :placeholder="$t('PLACEHOLDERS.driver_phone')"
                v-model.trim="filterOptions.phone" />

              <!-- End::company Name Input -->

              <!-- <base-select-input
                col="4"
                :optionsList="salons"
                :placeholder="$t('PLACEHOLDERS.phone')"
                v-model="filterOptions.phone"
              /> -->

              <!-- Start:: Status Input -->
              <base-select-input col="4" :optionsList="activeStatuses" :placeholder="$t('PLACEHOLDERS.status')"
                v-model="filterOptions.status" />
              <!-- End:: Status Input -->

              <!-- Start:: sender_email Input -->
              <!-- <base-input
                col="3"
                type="text"
                :placeholder="$t('PLACEHOLDERS.sender_email')"
                v-model="filterOptions.email"
              /> -->
              <!-- End:: sender_email Input -->
            </div>

            <div class="btns_wrapper">
              <button class="submit_btn" :disabled="isWaitingRequest">
                <i class="fal fa-search"></i>
              </button>
              <button class="reset_btn" type="button" :disabled="isWaitingRequest" @click="resetFilter">
                <i class="fal fa-redo"></i>
              </button>
            </div>
          </form>
        </div>
      </div>
      <!--  =========== End:: Filter Form =========== -->

      <!--  =========== Start:: Table Title =========== -->
      <div class="table_title_wrapper">
        <div class="title_text_wrapper">
          <h5>{{ $t("PLACEHOLDERS.driver-manegment") }}</h5>
          <button v-if="!filterFormIsActive" class="filter_toggler"
            @click.stop="filterFormIsActive = !filterFormIsActive">
            <i class="fal fa-search"></i>
          </button>
        </div>
      </div>
      <!--  =========== End:: Table Title =========== -->

      <!--  =========== Start:: Data Table =========== -->
      <v-data-table class="thumb" :loading="loading" :loading-text="$t('TABLES.loadingData')" :search="searchValue"
        :headers="tableHeaders" :items="tableRows" item-class="ltr" :items-per-page="paginations.items_per_page"
        hide-default-footer>
        <!-- Start:: No Data State -->
        <template v-slot:no-data>
          {{ $t("TABLES.noData") }}
        </template>
        <!-- Start:: No Data State -->

        <!-- Start:: Item Image -->
        <template v-slot:[`item.id`]="{ index }">
          <div class="table_image_wrapper">
            <!-- <h6 class="text-danger" v-if="!item.id">
              {{ $t("TABLES.noData") }}
            </h6> -->
            <p>
              {{
                (paginations.current_page - 1) * paginations.items_per_page +
                index +
                1
              }}
            </p>
          </div>
        </template>
        <!-- End:: Item Image -->

        <!-- Start:: Item is_verified -->
        <template v-slot:[`item.is_active`]="{ item }">
          <span class="text-success text-h5" v-if="item.is_active">
            <i class="far fa-check"></i>
          </span>
          <span class="text-danger text-h5" v-else>
            <i class="far fa-times"></i>
          </span>
        </template>
        <!-- End:: Item Image -->

        <!-- Start:: Title -->
        <template v-slot:[`item.title`]="{ item }">
          <p class="text-danger" v-if="!item.title">
            {{ $t("TABLES.noData") }}
          </p>
          <p v-else>{{ item.title }}</p>
        </template>

        <template v-slot:[`item.user.companyName`]="{ item }">
          <p class="text-danger" v-if="!item.user.companyName">
            {{ $t("TABLES.noData") }}
          </p>
          <p v-else>{{ item.user.companyName }}</p>
        </template>
        <!-- End:: Title -->

        <!-- Start:: Actions -->
        <template v-slot:[`item.actions`]="{ item }">
          <div class="actions">
            <a-tooltip placement="bottom">
              <template slot="title">
                <span>{{ $t("PLACEHOLDERS.wallet") }}</span>
              </template>
              <button class="btn_show" @click="selectWallet(item)">
                <i class="fas fa-wallet"></i>
              </button>
            </a-tooltip>
            <a-tooltip placement="bottom">
              <template slot="title">
                <span>{{ $t("BUTTONS.edit") }}</span>
              </template>
              <button class="btn_edit" @click="editItem(item)">
                <i class="fal fa-edit"></i>
              </button>
            </a-tooltip>
            <a-tooltip placement="bottom">
              <template slot="title">
                <span>{{ $t("BUTTONS.show") }}</span>
              </template>
              <button class="btn_show" @click="showItem(item)">
                <i class="fal fa-eye"></i>
              </button>
            </a-tooltip>
            <a-tooltip placement="bottom">
              <template slot="title">
                <span>{{ $t("BUTTONS.delete") }}</span>
              </template>
              <button class="btn_delete" @click="selectDeleteItem(item)">
                <i class="fal fa-trash-alt"></i>
              </button>
            </a-tooltip>

            <div class="actions">
              <a-tooltip placement="bottom" v-if="!item.is_active">
                <template slot="title">
                  <span>{{ $t("BUTTONS.activate") }}</span>
                </template>
                <button class="btn_activate" @click="activeItem(item)">
                  <i class="fad fa-check-circle"></i>
                </button>
              </a-tooltip>
              <a-tooltip placement="bottom" v-else>
                <template slot="title">
                  <span>{{ $t("BUTTONS.deactivate") }}</span>
                </template>
                <button class="btn_deactivate" @click="selectDeactivateItem(item)">
                  <i class="fad fa-times-circle"></i>
                </button>
              </a-tooltip>
            </div>
          </div>
        </template>
        <!-- End:: Actions -->

        <!-- ======================== Start:: Dialogs ======================== -->
        <template v-slot:top>
          <!-- Start:: Image Modal -->
          <image-modal v-if="dialogImage" :modalIsOpen="dialogImage" :modalImage="selectedItemImage"
            @toggleModal="dialogImage = !dialogImage" />
          <!-- End:: Image Modal -->

          <!-- Start:: Description Modal -->
          <description-modal v-if="dialogDescription" :modalIsOpen="dialogDescription"
            :modalDesc="selectedDescriptionTextToShow" @toggleModal="dialogDescription = !dialogDescription" />
          <!-- End:: Description Modal -->

          <v-dialog v-model="dialogStatusAccept">
            <v-card>
              <v-card-title class="text-h5 justify-center">
                {{ $t("PLACEHOLDERS.accept_settlement_request") }}
              </v-card-title>
              <div class="w-100">
                <div class="mt-3">
                  <h6 class="d-inline-block font-weight-bold mb-4">
                    {{ $t("SIDENAV.Clients.user_balance") }}:
                  </h6>
                  <h6 class="d-inline-block mx-1">
                    {{ modalRequest?.amount }}
                    {{ $t("PLACEHOLDERS.riyal") }}
                  </h6>
                  <div>
                    <label class="font-weight-bold mx-1">{{ $t("PLACEHOLDERS.settlement_request_money") }}:
                    </label>
                    <input type="number" v-model.trim="modalRequest.money" class="bg-white rounded mx-3 p-2 w-25" />
                    <span>{{ $t("PLACEHOLDERS.riyal") }}</span>
                    <div class="text-center mt-5">
                      <v-btn class="modal_confirm_btn mx-1 bg-success text-white"
                        @click="changeRequestStatus(modalRequest, 'accepted')">{{ $t("BUTTONS.save") }}</v-btn>
                      <v-btn class="modal_confirm_btn mx-1 bg-danger text-white" @click="cancelRequest()">{{
                        $t("BUTTONS.cancel") }}</v-btn>
                    </div>
                  </div>
                </div>
              </div>
            </v-card>
          </v-dialog>

          <v-dialog v-model="dialogStatusReject">
            <v-card>
              <!-- <v-card-title class="text-h5 justify-center">
                {{ $t("PLACEHOLDERS.accept_settlement_request") }}
              </v-card-title> -->
              <div class="w-100">
                <div class="mt-3">
                  <div>
                    <label class="font-weight-bold mx-1">{{ $t("PLACEHOLDERS.reason_reject") }}:
                    </label>
                    <input type="textarea" rows="4" v-model.trim="modalRequest.reason"
                      class="bg-white rounded p-2 w-100 mt-4" />
                    <div class="text-center mt-5">
                      <v-btn class="modal_confirm_btn mx-1 bg-success text-white"
                        @click="changeRequestStatus(modalRequest, 'rejected')">{{ $t("BUTTONS.save") }}</v-btn>
                      <v-btn class="modal_confirm_btn mx-1 bg-danger text-white" @click="cancelRequest()">{{
                        $t("BUTTONS.cancel") }}</v-btn>
                    </div>
                  </div>
                </div>
              </div>
            </v-card>
          </v-dialog>
          <v-dialog v-model="dialogDeactivate">
            <v-card>
              <v-card-title class="text-h5 justify-center" v-if="itemToChangeActivationStatus">
                {{
                  $t("TITLES.rejectblockMessage", {
                    name: itemToChangeActivationStatus.name,
                  })
                }}
              </v-card-title>

              <form class="w-100">
                <base-input col="12" rows="3" type="textarea" :placeholder="$t('PLACEHOLDERS.block_reject')"
                  v-model.trim="deactivateReason" required />
              </form>

              <v-card-actions>
                <v-btn class="modal_confirm_btn" @click="
                  HandlingItemActivationStatus(itemToChangeActivationStatus)
                  " :disabled="!!!deactivateReason || deactivateReason?.length < 3
                    ">
                  {{ $t("BUTTONS.ok") }}
                </v-btn>

                <v-btn class="modal_cancel_btn" @click="dialogDeactivate = false">{{ $t("BUTTONS.cancel") }}</v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog v-model="dialogWallet">
            <v-card>
              <v-card-title class="text-h5 justify-center" v-if="providerWallet">
                {{ $t("PLACEHOLDERS.balance") + " " + providerWallet?.balance }}
              </v-card-title>
              <v-card-title>
                <div class="mx-3">
                  {{ $t("PLACEHOLDERS.profit") + " " + providerWallet?.profit }}
                </div>
                <div class="mx-3">
                  {{ $t("PLACEHOLDERS.debts") + " " + providerWallet?.debts }}
                </div>
              </v-card-title>

              <form class="w-100">
                <base-input col="12" rows="3" type="text" :placeholder="$t('PLACEHOLDERS.newBalance')"
                  v-model.trim="newBalance" required />
              </form>

              <v-card-actions>
                <v-btn class="modal_confirm_btn" @click="changeBalance(providerWallet)"
                  :disabled="!!!newBalance || newBalance?.length < 0">
                  {{ $t("BUTTONS.ok") }}
                </v-btn>

                <v-btn class="modal_cancel_btn" @click="dialogWallet = false">{{
                  $t("BUTTONS.cancel")
                }}</v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </template>
        <!-- ======================== End:: Dialogs ======================== -->
      </v-data-table>
      <!--  =========== End:: Data Table =========== -->
    </main>
    <!-- End:: Main Section -->

    <!-- Start:: Pagination -->
    <template>
      <div class="pagination_container text-center mt-3 mb-0">
        <v-pagination class="py-0" square v-model="paginations.current_page" :length="paginations.last_page"
          :total-visible="6" @input="updateRouterQueryParam($event)" :prev-icon="getAppLocale == 'ar' ? 'fal fa-angle-right' : 'fal fa-angle-left'
            " :next-icon="getAppLocale == 'ar' ? 'fal fa-angle-left' : 'fal fa-angle-right'
              " />
      </div>
    </template>
    <!-- End:: Pagination -->
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "AllRegions",

  computed: {
    ...mapGetters({
      getAppLocale: "AppLangModule/getAppLocale",
      getCountriesData: "ApiGetsModule/allCountriesData",
    }),

    activeStatuses() {
      return [
        {
          id: null,
          name: this.$t("STATUS.all"),
          value: null,
        },
        {
          id: 1,
          name: this.$t("STATUS.active"),
          value: 1,
        },
        {
          id: 2,
          name: this.$t("STATUS.notActive"),
          value: 0,
        },
      ];
    },
  },

  data() {
    return {
      // Start:: Loading Data
      itemToChangeActivationStatus: null,
      loading: false,
      isWaitingRequest: false,
      // End:: Loading Data

      // Start:: Filter Data
      filterFormIsActive: false,
      filterOptions: {
        provider_name: null,
        shop_name: null,
        phone: null,
        email: null,
        status: null,
      },

      salons: [],
      // End:: Filter Data

      // Start:: Table Data
      searchValue: "",
      tableHeaders: [
        {
          text: this.$t("TABLES.Admins.serialNumber"),
          value: "id",
          align: "center",
          sortable: false,
        },
        {
          text: this.$t("PLACEHOLDERS.driver_name"),
          value: "name",
          sortable: false,
          align: "center",
        },
        // {
        //   text: this.$t("PLACEHOLDERS.store_name"),
        //   value: "store_name",
        //   sortable: false,
        //   align: "center",
        // },
        {
          text: this.$t("PLACEHOLDERS.phone"),
          value: "mobile",
          sortable: false,
          align: "center",
        },
        {
          text: this.$t("PLACEHOLDERS.sender_email"),
          value: "email",
          sortable: false,
          align: "center",
        },
        {
          text: this.$t("PLACEHOLDERS.created_at"),
          value: "created_at",
          sortable: false,
          align: "center",
        },
        {
          text: this.$t("PLACEHOLDERS.status"),
          value: "is_active",
          align: "center",
          sortable: false,
          width: "120",
        },
        {
          text: this.$t("TABLES.Roles.actions"),
          value: "actions",
          sortable: false,
          align: "center",
        },
      ],
      tableRows: [],
      // End:: Table Data

      // Start:: Dialogs Control Data

      dialogStatusAccept: false,
      dialogStatusReject: false,

      dialogWallet: false,
      dialogImage: false,
      providerWallet: null,
      newBalance: null,
      selectedItemImage: null,
      dialogDescription: false,
      selectedDescriptionTextToShow: "",
      dialogDelete: false,
      itemToDelete: null,
      // End:: Dialogs Control Data

      // Start:: Pagination Data
      paginations: {
        current_page: 1,
        last_page: 1,
        items_per_page: 6,
      },
      // End:: Pagination Data

      currentRequest: {
        money: null,
        reason: "",
      },
      modalRequest: {},
      dialogDeactivate: false,
      deactivateReason: null,
    };
  },

  watch: {
    // Start:: Page Query Param Watcher To Get Page Data Based On It's Change
    ["$route.query.page"]() {
      this.paginations.current_page = +this.$route.query.page;
      this.setTableRows();
    },
    // End:: Page Query Param Watcher To Get Page Data Based On It's Change
  },

  methods: {
    // Start:: Vuex Actions
    ...mapActions({
      getCountries: "ApiGetsModule/getCountries",
    }),

    async changeBalance(selectedItem) {
      this.dialogWallet = false;
      let targetItem = selectedItem;
      const REQUEST_DATA = {};
      if (this.newBalance) {
        REQUEST_DATA.balance = this.newBalance;
      }
      try {
        let res = await this.$axios({
          method: "POST",
          url: `driver-wallet/${targetItem.id}`,
          data: REQUEST_DATA,
        });
        this.$message.success(res?.data.message);
        this.setTableRows();
        this.providerWallet = null;
        this.newBalance = null;
      } catch (error) {
        this.$message.error(error.response.data.message);
      }
    },
    async HandlingItemActivationStatus(selectedItem) {
      this.dialogDeactivate = false;
      let targetItem = selectedItem;
      const REQUEST_DATA = {};
      // Start:: Append Request Data
      if (this.deactivateReason) {
        REQUEST_DATA.reason = this.deactivateReason;
      }
      // REQUEST_DATA.status = 'rejected';
      // Start:: Append Request Data
      try {
        await this.$axios({
          method: "POST",
          url: `driver-block/${targetItem.id}`,
          data: REQUEST_DATA,
        });
        this.$message.success(this.$t("MESSAGES.changeActivation"));
        this.setTableRows();
        this.itemToChangeActivationStatus = null;
        this.deactivateReason = null;
      } catch (error) {
        this.$message.error(error.response.data.message);
      }
    },
    selectDeactivateItem(item) {
      this.dialogDeactivate = true;
      this.itemToChangeActivationStatus = item;
    },
    selectWallet(item) {
      this.dialogWallet = true;
      this.providerWallet = item;
      console.log("wallet", this.providerWallet);
    },
    // End:: Vuex Actions
    async activeItem(selectedItem) {
      // this.dialogDeactivate = false;
      let targetItem = selectedItem;
      const REQUEST_DATA = {};
      // Start:: Append Request Data
      // REQUEST_DATA.status = 'accepted';
      // Start:: Append Request Data
      try {
        await this.$axios({
          method: "POST",
          url: `driver-activate/${targetItem.id}`,
          data: REQUEST_DATA,
        });
        this.$message.success(this.$t("MESSAGES.changeActivation"));
        this.setTableRows();
      } catch (error) {
        this.$message.error(error.response.data.message);
      }
    },
    // Start:: Handel Filter
    async submitFilterForm() {
      if (this.$route.query.page !== "1") {
        await this.$router.push({
          path: "/driver-manegment/all",
          query: { page: 1 },
        });
      }
      this.setTableRows();
    },

    // ===== End:: Delete
    // start accepted  provider request
    async approvedProviders(item) {
      const REQUEST_DATA = new FormData();
      REQUEST_DATA.append("is_joined", 1);
      try {
        await this.$axios({
          method: "POST",
          url: `refuse_provider_join_requests/${item.user.id}`,
          data: REQUEST_DATA,
        });
        this.setTableRows();

        this.$message.success(this.$t("MESSAGES.accept_join_request"));
      } catch (error) {
        this.$message.error(error.response.data.message);
      }
    },

    async selectDeleteItem(itemToDelete) {
      const REQUEST_DATA = new FormData();
      REQUEST_DATA.append("_method", "delete");
      try {
        await this.$axios.post(`drivers/${itemToDelete.id}`, REQUEST_DATA);
        this.setTableRows();
        this.$message.success(this.$t("MESSAGES.deletedSuccessfully"));
      } catch (error) {
        this.$message.error(error.response.data.message);
      }
    },
    // end accepted provider request
    async resetFilter() {
      this.filterOptions.provider_name = null;
      this.filterOptions.shop_name = null;
      this.filterOptions.phone = null;
      this.filterOptions.email = null;
      this.filterOptions.status = null;

      if (this.$route.query.page !== "1") {
        await this.$router.push({
          path: "/driver-manegment/all",
          query: { page: 1 },
        });
      }
      this.setTableRows();
    },
    // End:: Handel Filter

    // Start:: Set Table Rows
    updateRouterQueryParam(pagenationValue) {
      this.$router.push({
        query: {
          ...this.$route.query,
          page: pagenationValue,
        },
      });

      // Scroll To Screen's Top After Get Products
      document.body.scrollTop = 0; // For Safari
      document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    },
    async setTableRows() {
      this.loading = true;
      try {
        let res = await this.$axios({
          method: "GET",
          url: "drivers",

          params: {
            page: this.paginations.current_page,
            name: this.filterOptions.provider_name,
            store_name: this.filterOptions.shop_name,
            mobile: this.filterOptions.phone,
            email: this.filterOptions.email,
            is_active: this.filterOptions.status?.value,
          },
        });

        this.loading = false;
        this.tableRows = res.data.data.data;
        this.paginations.last_page = res.data.data.meta.last_page;
        this.paginations.items_per_page = res.data.data.meta.per_page;
      } catch (error) {
        this.loading = false;
        console.log(error.response.data.message);
      }
    },
    // End:: Set Table Rows

    // Start:: Change Activation Status
    openRequestStatusModal(item, status) {
      if (status == "accepted") {
        this.changeRequestStatus(item, status);
      } else if (status == "rejected") {
        this.dialogStatusReject = true;
      }
      this.modalRequest = { ...item };
      this.currentRequest = item;
    },
    async changeRequestStatus(modalRequest, status) {
      const REQUEST_DATA = new FormData();
      REQUEST_DATA.append("status", status);

      if (status === "rejected" && modalRequest?.reason) {
        REQUEST_DATA.append("reason", modalRequest?.reason);
      }
      // if (status === "accepted" && modalRequest?.money) {
      //   REQUEST_DATA.append("amount", modalRequest?.money);
      // }

      try {
        let res = await this.$axios({
          method: "POST",
          url: `providers/change-status/${modalRequest.id}`,
          data: REQUEST_DATA,
        });

        this.setTableRows();
        this.dialogStatusAccept = false;
        this.dialogStatusReject = false;
        this.$message.success(res.data.message);
      } catch (error) {
        this.$message.error(error.response.data.message);
      }
    },

    cancelRequest() {
      this.dialogStatusAccept = false;
      this.dialogStatusReject = false;
    },
    // End:: Change Activation Status

    // ==================== Start:: Crud ====================
    // ===== Start:: End
    editItem(item) {
      this.$router.push({ path: `/driver-manegment/edit/${item.id}` });
    },

    showItem(item) {
      this.$router.push({ path: `/driver-manegment/show/${item.id}` });
    },
    // ===== End:: End

    // ===== Start:: Delete
    // selectDeleteItem(item) {
    //   this.dialogDelete = true;
    //   this.itemToDelete = item;
    // },

    // ===== End:: Delete

    async getSalons() {
      this.loading = true;
      try {
        let res = await this.$axios({
          method: "GET",
          url: `salons?isVerified=1&page=0&limit=0`,
        });

        this.salons = res.data.data;
      } catch (error) {
        this.loading = false;
        console.log(error.response.data.message);
      }
    },

    // ==================== End:: Crud ====================
  },

  created() {
    this.getSalons();

    // Start:: Fire Methods
    window.addEventListener("click", () => {
      this.filterFormIsActive = false;
    });
    if (this.$route.query.page) {
      this.paginations.current_page = +this.$route.query.page;
    }
    this.setTableRows();

    // End:: Fire Methods
  },
};
</script>
